import React, { useContext } from 'react';
import { toast } from 'react-toastify';
import BookmarkContext from './context/BookmarkContext';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const {
    handleModal,
    saveSite,
    siteLogo,
    setSiteLogo,
    siteName,
    setSiteName,
    setSiteURL,
    siteURL,
    openModal,
    toggleButton,
    updateSite,
    searchTerm,
    setSearchTerm,
    sortOrder,
    handleSortChange,
    setBookmarkData,
    bookmarkData,
    handleProfile,
    toggleProfile,
    handleProfileClose,
    userName,
    email,
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    handleChangePassword,
    loading,
    handleClearComponent
  } = useContext(BookmarkContext);

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('User');
    localStorage.removeItem('token');
    localStorage.removeItem('Verified');
    localStorage.removeItem('Admin');
    toast.success("Logout Successfully");
    navigate("/home");
    setBookmarkData([]);
    handleClearComponent();
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark px-3">
        <div className="container-fluid">
          <Link className="navbar-brand fw-bold fs-4 cursor-pointer" to={localStorage.getItem("User") ? "/bookmark" : "/home"}>
            📌 BookMarks
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div className="collapse navbar-collapse gap-3 navbar-1" id="navbarSupportedContent">
            {localStorage.getItem("User") ? (
              <>
                <div className='d-flex flex-row gap-3'>
                  <select
                    className="form-select"
                    style={{ width: "100px" }}
                    value={sortOrder}
                    onChange={handleSortChange}
                    disabled={bookmarkData.length === 0}
                  >
                    <option value="">Default</option>
                    <option value="1">Ascending Order</option>
                    <option value="2">Descending Order</option>
                  </select>

                  <form role="search">
                    <input
                      className="form-control"
                      type="search"
                      placeholder="Search sites"
                      aria-label="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      disabled={bookmarkData.length === 0}
                    />
                  </form>
                </div>

                <div className='d-flex align-items-center gap-3'>
                  <button
                    type="button"
                    onClick={handleModal}
                    className="btn btn-primary rounded-4 bg-light border-0 text-black"
                  >
                    + Add Site
                  </button>

                  <button
                    type="button"
                    onClick={handleLogout}
                    className="btn btn-primary rounded-4 bg-light border-0 text-black"
                  >
                    Logout
                  </button>

                  <i className="fa-solid fa-user fs-4 cursor-pointer" onClick={handleProfile} style={{ color: "white" }}></i>
                </div>
              </>
            ) : (
              <div className='d-flex flex-row gap-4'>
                <i
                  className="fa-solid fa-right-to-bracket fs-4 cursor-pointer"
                  style={{
                    color: "white",
                    opacity: loading ? 0.5 : 1,
                    pointerEvents: loading ? "none" : "auto"
                  }}
                  onClick={!loading ? async () => {
                    navigate("/login");
                    await handleClearComponent();
                  } : null}
                ></i>

                <i
                  className="fa-solid fa-user-plus fs-4 cursor-pointer"
                  style={{
                    color: "white",
                    opacity: loading ? 0.5 : 1,
                    pointerEvents: loading ? "none" : "auto"
                  }}
                  onClick={
                    !loading ? async () => {
                      navigate("/signup");
                      await handleClearComponent();
                    } : null}
                ></i>
              </div>

            )}
          </div>
        </div>
      </nav>

      {/* Modal */}
      {openModal && (
        <div className="modal d-block bg-dark bg-opacity-75" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded-4 shadow"
              style={{
                backgroundImage:
                  'url("https://website-app-assets.netlify.app/assets/backgroung-modal-CarRQnwf.jpg")',
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundAttachment: "fixed",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title text-light">
                  {toggleButton ? "Add" : "Update"} Site to Bookmarks
                </h5>
                <button
                  type="button"
                  className="btn-close bg-light"
                  onClick={handleModal}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              {/* Form start */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  toggleButton ? saveSite() : updateSite();
                }}
              >
                <div className="modal-body">
                  <div className="mb-3">
                    <label htmlhtmlFor="site-name" className="form-label text-light">
                      Site Name:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="site-name"
                      value={siteName}
                      onChange={(e) => setSiteName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlhtmlFor="site-url" className="form-label text-light">
                      Site URL:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="site-url"
                      value={siteURL}
                      onChange={(e) => setSiteURL(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlhtmlFor="image-url" className="form-label text-light">
                      Site Logo URL (Optional):
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="image-url"
                      value={siteLogo}
                      onChange={(e) => setSiteLogo(e.target.value)}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleModal}
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button type="submit" className="btn btn-primary" disabled={siteName.length <= 3 || siteURL.length <= 5 ||
                    (siteLogo && siteLogo.length <= 5)}>
                    {toggleButton ? "Save Site" : "Update Site"}
                  </button>
                </div>
              </form>
              {/* Form end */}
            </div>
          </div>
        </div>
      )}

      {
        toggleProfile &&
        <div className="modal d-block bg-dark bg-opacity-75" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-4 shadow-lg">
              <div className="modal-header bg-primary text-white rounded-top-4">
                <h5 className="modal-title">Account Details</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleProfileClose}
                ></button>
              </div>

              <div className="modal-body">
                {/* Name */}
                <div className="row mb-3 align-items-center">
                  <label htmlFor="staticName" className="col-sm-4 col-form-label">Name</label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      id="staticName"
                      value={userName}
                      disabled
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="row mb-3 align-items-center">
                  <label htmlFor="staticEmail" className="col-sm-4 col-form-label">Email</label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control"
                      id="staticEmail"
                      value={email}
                      disabled
                    />
                  </div>
                </div>

                {/* Change Password Section */}
                <div className="border-top pt-3">
                  <h6 className="fw-semibold mb-4">Change Password</h6>

                  <div className="row mb-3 align-items-center">
                    <label className="col-sm-4 col-form-label">Current Password</label>
                    <div className="col-sm-8">
                      <input
                        type="password"
                        className="form-control"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder="Enter current password"
                      />
                    </div>
                  </div>

                  <div className="row mb-3 align-items-center">
                    <label className="col-sm-4 col-form-label">New Password</label>
                    <div className="col-sm-8">
                      <input
                        type="password"
                        className="form-control"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter new password"
                      />
                    </div>
                  </div>

                  <div className="row mb-3 align-items-center">
                    <label className="col-sm-4 col-form-label">Confirm Password</label>
                    <div className="col-sm-8">
                      <input
                        type="password"
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm new password"
                      />
                      {
                        newPassword !== confirmPassword ? <div className="text-danger">
                          Password is not Matching
                        </div> : ""
                      }

                    </div>
                  </div>
                </div>
              </div>


              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleProfileClose}>
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleChangePassword}
                  disabled={currentPassword.length < 5 || newPassword.length < 5 || newPassword !== confirmPassword}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>

      }
    </>
  );
};

export default Navbar;
